import { Link } from "react-router-dom";
import { useGetAllSocialMediaLinksQuery } from "Services/Admin/SocialMediaApiSlice";
import { SocialMediaLink } from "Types/Admin/SocialMediaLinks";

const SocialMediaLinks = () => {
  const plant = process.env.REACT_APP_PLANT;

  const { data: socialMediaData } = useGetAllSocialMediaLinksQuery({
    plant,
  });

  const enabledAccounts = socialMediaData?.results
    ? (Array.isArray(socialMediaData.results)
        ? socialMediaData.results
        : [socialMediaData.results]
      ).filter((account: SocialMediaLink) => account.showHide === 1)
    : [];

  const getAccountIcon = (accountType: string, socialMediaUrl: string) => {
    const iconProps = {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      className:
        "text-vintageText opacity-100",
    };

    switch (accountType) {
      case "instagram":
        return (
          <Link
            to={socialMediaUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="text-vintageText opacity-100"
          >
            <img
              src="/social/instagram.svg"
              alt="Whatsapp icon"
              className="h-8 w-auto mx-auto md:mx-0 rounded"
            />
          </Link>
        );

      case "facebook":
        return (
          <Link
            to={socialMediaUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="text-vintageText opacity-100"
          >
            <img
              src="/social/facebook.svg"
              alt="Whatsapp icon"
              className="h-8 w-auto mx-auto md:mx-0 rounded"
            />
          </Link>
        );

      case "tiktok":
        return (
          <Link
            to={socialMediaUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="text-vintageText opacity-100"
          >
            <img
              src="/social/tiktok.svg"
              alt="Whatsapp icon"
              className="h-8 w-auto mx-auto md:mx-0 rounded"
            />
          </Link>
        );

      case "twitter":
        return (
          <Link
            to={socialMediaUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="text-vintageText opacity-100"
          >
            <img
              src="/social/twitter.svg"
              alt="Whatsapp icon"
              className="h-8 w-auto mx-auto md:mx-0 rounded"
            />
          </Link>
        );

      case "linkedin":
        return (
          <Link
            to={socialMediaUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="text-vintageText opacity-100"
          >
            <img
              src="/social/linkedin.svg"
              alt="Whatsapp icon"
              className="h-8 w-auto mx-auto md:mx-0 rounded"
            />
          </Link>
        );

      case "youtube":
        return (
          <Link
            to={socialMediaUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="text-vintageText opacity-100"
          >
            <img
              src="/social/youtube.svg"
              alt="Whatsapp icon"
              className="h-8 w-auto mx-auto md:mx-0 rounded"
            />
          </Link>
        );

      default:
        return null;
    }
  };

  return (
    <div className="order-1 md:order-3 flex space-x-4 mb-20 md:mb-0">
      {enabledAccounts.length > 0
        ? enabledAccounts.map((account: SocialMediaLink) => (
            <div key={account.id}>
              {getAccountIcon(account.accountType, account.socialMediaUrl)}
            </div>
          ))
        : ""}
    </div>
  );
};

export default SocialMediaLinks;
